import { render, staticRenderFns } from "./ConfigBooking.vue?vue&type=template&id=9fd235fe"
import script from "./ConfigBooking.vue?vue&type=script&lang=ts"
export * from "./ConfigBooking.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports